import Vue from "vue";

import InputText from "./InputText.vue";
import InputDate from "./InputDate.vue";
import InputRadio from "./InputRadio.vue";
import InputRadioItem from "./InputRadioItem.vue";
import InputSelect from "./InputSelect.vue";

Vue.component("c-input", InputText);
Vue.component("c-input-date", InputDate);
Vue.component("c-input-wrap", InputDate);
Vue.component("c-input-radio", InputRadio);
Vue.component("c-input-radio-item", InputRadioItem);
Vue.component("c-input-select", InputSelect);
